import { consultationApi } from '@/core/api/consultation'

export const {
  useGetConsultationQuery,
  useGetConsultationsQuery,
  useGetConsultationReasonsQuery,
  useCreateConsultationMutation,
  useUpdateConsultationMutation,
  useEndConsultationMutation,
  useCreateConsultationBiologicalMutation,
  useAddConsultationBiologicalFileMutation,
  useAddBiologicalDocumentMetadataMutation,
  useCreateConsultationDictaphoneMutation,
  useDeleteConsultationBiologicalMutation,
  useDeleteConsultationBiologicalFilesMutation,
  useDeleteConsultationDictaphoneMutation,
  useSendMesuresSocketMutation,
  useGetConsultationSettingsQuery,
  useUpdateConsultationSettingsMutation,
  useRetryDesmosActsMutation,
  useAddManualDesmosActMutation,
  useUpdateBillingReviewMutation,
  useSetConsultationReadinessMutation,
  useCreateConsultationReasonMutation,
  useUpdateConsultationReasonMutation,
  useDeleteConsultationReasonMutation,
} = consultationApi
